import {Component, Input} from '@angular/core';
import {CompanyStatusTone, getCompanyStatusMeta} from '../shared/company-status';

@Component({
    selector: 'app-companies-settings-status-badge',
    templateUrl: './companies-settings-status-badge.component.html',
    styles: [':host { display: inline-flex; }']
})
export class CompaniesSettingsStatusBadgeComponent {
    @Input() status = '';
    @Input() meta?: {label: string; tone: CompanyStatusTone};

    get label(): string {
        return this.meta?.label ?? getCompanyStatusMeta(this.status).label;
    }

    get tone(): CompanyStatusTone {
        return this.meta?.tone ?? getCompanyStatusMeta(this.status).tone;
    }

    get toneClasses(): string {
        switch (this.tone) {
            case 'success':
                return '!bg-emerald-100 !text-emerald-700';
            case 'warning':
                return '!bg-amber-100 !text-amber-800';
            case 'danger':
                return '!bg-red-100 !text-red-700';
            default:
                return '!bg-slate-100 !text-slate-600';
        }
    }
}
